/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_OrderInputs */

const en_tables_custom_pages_order = /** @type {(inputs: Tables_Custom_Pages_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pages Order`)
};

const de_tables_custom_pages_order = /** @type {(inputs: Tables_Custom_Pages_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reihenfolge`)
};

/**
* | output |
* | --- |
* | "Pages Order" |
*
* @param {Tables_Custom_Pages_OrderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_order = /** @type {((inputs?: Tables_Custom_Pages_OrderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_OrderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_order(inputs)
	return de_tables_custom_pages_order(inputs)
});